var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.manifestQueryLog"),
        width: "600px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.isSeaHouseChannel
            ? _vm.housekeeper
            : _vm.columnDefs,
          "grid-params": _vm.gridParams,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          },
          gridReady: _vm.onGridReady
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }